<template>
    <div class="site-managing">
        <mc-operate-bar>
            <template slot="left">
                <mc-search-bar v-model="searchParmas" search-label="输入站点名称" :search-submit="$_getTableList"></mc-search-bar>
            </template>
            <template slot="right">
                <el-button type="primary" @click="dialog.site.methods.open()">新增站点</el-button>
            </template>
        </mc-operate-bar>
        <mc-table ref="mc-table" :table-option="tableOption" v-loading="tableOption.loading">
            <template slot="table-components">
                <el-table-column sortable :prop="tableOption.head[0].prop" :label="tableOption.head[0].label" :width="tableOption.head[0].width"
                    v-if="tableOption.head.length>0"></el-table-column>
                <el-table-column sortable :prop="tableOption.head[1].prop" :label="tableOption.head[1].label" :width="tableOption.head[1].width"
                    v-if="tableOption.head.length>0"></el-table-column>
                <el-table-column :prop="tableOption.head[2].prop" :label="tableOption.head[2].label" :width="tableOption.head[2].width"
                    v-if="tableOption.head.length>0">
                    <template slot-scope="scope">
                        <span class="deal-item key" @click="dialog.key.methods.open(scope.row)">{{scope.row.access_key}}</span>
                    </template>
                </el-table-column>
                <el-table-column sortable :prop="tableOption.head[3].prop" :label="tableOption.head[3].label" :width="tableOption.head[3].width"
                    v-if="tableOption.head.length>0">
                    <template slot-scope="scope">
                        {{$_handleTime(scope.row.create_at)}}
                    </template>
                </el-table-column>
                <el-table-column sortable :prop="tableOption.head[4].prop" :label="tableOption.head[4].label" :width="tableOption.head[4].width"
                    v-if="tableOption.head.length>0">
                    <template slot-scope="scope">
                        {{$_handleTime(scope.row.license_end)}}
                    </template>
                </el-table-column>
            </template>
        </mc-table>
        <mc-pager :pager-option.sync="pager" ref="site-managing-pager" @getList="$_getTableList"></mc-pager>

        <mc-dialog :dialog-option.sync="dialog.key">
            <template slot="content">
                <mc-label info>{{this.dialog.key.data.key}}</mc-label>
            </template>
        </mc-dialog>

        <mc-dialog :dialog-option.sync="dialog.delete">
            <template slot="content">
                <mc-label icon="el-icon-error" error>删除后不可恢复，确定删除这个站点吗？</mc-label>
            </template>
        </mc-dialog>

        <mc-dialog :dialog-option.sync="dialog.reset">
            <template slot="content">
                <mc-label icon="el-icon-error" warn>确定重置该站点密钥吗？</mc-label>
            </template>
        </mc-dialog>

        <mc-dialog :dialog-option.sync="dialog.site">
            <template slot="content">
                <mc-layout-row label-text="站点名称" :labelWidth="170" important>
                    <el-input placeholder="请填写" v-model="dialog.site.data.site.site_name"></el-input>
                </mc-layout-row>
                <mc-layout-row label-text="省" :labelWidth="170" important>
                    <el-select style="width:100%" placeholder="请选择" v-model="dialog.site.data.province" @change="$_getCitysList">
                        <el-option v-for="item in provinceSelect" :key="item.value" :label="item.label" :value="item.value"></el-option>
                    </el-select>
                </mc-layout-row>
                <mc-layout-row label-text="市" :labelWidth="170" important>
                    <el-select style="width:100%" placeholder="请选择" v-model="dialog.site.data.city" @change="$_getDistrictsList">
                        <el-option v-for="item in citySelect" :key="item.value" :label="item.label" :value="item.value">
                        </el-option>
                    </el-select>
                </mc-layout-row>
                <mc-layout-row label-text="区/县" :labelWidth="170" important>
                    <el-select style="width:100%" placeholder="请选择" v-model="dialog.site.data.district" @change="$_selectRegion">
                        <el-option v-for="item in districtsSelect" :key="item.value" :label="item.label" :value="item.value">
                        </el-option>
                    </el-select>
                </mc-layout-row>
                <mc-layout-row label-text="详细地址" :labelWidth="170" important>
                    <el-input style="width:100%" placeholder="请填写" v-model="dialog.site.data.site.address"></el-input>
                </mc-layout-row>
                <mc-layout-row label-text="授权结束日期" :labelWidth="170" content-align-row="left" important>
                    <el-date-picker style="width:100%" placeholder="请选择" v-model="dialog.site.data.site.license_end" type="date" format="yyyy/MM/dd" value-format="yyyy-MM-dd"></el-date-picker>
                </mc-layout-row>
                <div
                  v-if="dialog.site.data.row"
                  class="editor-tip">
                  修改站点编号与密钥
                  <i class="el-icon-question" @click="showTip()" style="color: #999"></i>
                  <i class="el-icon-arrow-up" @click="showMore()" v-if="dialog.site.data.showMore"></i>
                  <i class="el-icon-arrow-down" @click="showMore()" v-else></i>
                </div>
                <mc-layout-row
                  v-if="dialog.site.data.row && dialog.site.data.showMore"
                  label-text="站点编号" :labelWidth="170" important>
                    <el-input placeholder="请填写" v-model="dialog.site.data.site.sn"></el-input>
                </mc-layout-row>
                <mc-layout-row
                  v-if="dialog.site.data.row && dialog.site.data.showMore"
                  label-text="密钥" :labelWidth="170" important>
                    <el-input placeholder="请填写" v-model="dialog.site.data.site.access_key"></el-input>
                </mc-layout-row>
                <el-dialog
                  class="dialog-tip"
                  title="提示"
                  :visible.sync="dialog.site.data.showTip"
                  append-to-body>
                  <p>站点编号与密钥信息从license文件中获取，如下图</p>
                  <img src="./sn.png" width="100%" />
                </el-dialog>
            </template>
        </mc-dialog>
    </div>
</template>

<script>
    import SparkMD5 from 'spark-md5'

    export default {
        name: "site-managing",
        data() {
            return {
                searchParmas: '',
                pager: {
                    page: 1,
                    per_page: 10,
                    per_pages: [10, 20, 30, 40, 50],
                    total: 0,
                },
                provinceList: [],
                provinceSelect: [],
                cityList: [],
                citySelect: [],
                districtsList: [],
                districtsSelect: [],
                fileList: [],
                tableOption: {
                    loading: false,
                    index: {
                        disable: true,
                    },
                    operations: {
                        disable: true,
                        label: "操作",
                        items: [{
                                label: "修改",
                                type: "primary",
                                size: "mini",
                                click: (index, row) => {
                                    this.dialog.site.methods.open(row);
                                }
                            }, {
                                label: "删除",
                                type: "danger",
                                size: "mini",
                                click: (index, row) => {
                                    this.dialog.delete.methods.open(row);
                                }
                            },
                            {
                                label: "密钥",
                                type: "warning",
                                size: "mini",
                                click: (index, row) => {
                                    this.dialog.reset.methods.open(row);
                                }
                            }
                        ]
                    },
                    head: [{
                            prop: "site_name",
                            label: "告警站点",
                            width: "200",
                        },
                        {
                            prop: "sn",
                            label: "站点编号",
                            width: "200",
                        },
                        {
                            prop: "access_key",
                            label: "密钥",
                            width: "",
                        },
                        {
                            prop: "create_at",
                            label: "创建时间",
                            width: "150",
                        },
                        {
                            prop: "license_end",
                            label: "授权结束日期",
                            width: "150",
                        },
                    ],
                    data: [],
                },
                dialog: {
                    key: {
                        visible: false,
                        title: "密钥",
                        style: {
                            showConfirm: false,
                            showCancel: false,
                        },
                        methods: {
                            open: (item) => {
                                this.dialog.key.visible = true;
                                this.dialog.key.data.key = item.access_key;
                            },
                        },
                        data: {
                            key: "",
                        },
                    },
                    site: {
                        visible: false,
                        title: "修改站点信息",
                        style: {
                            showConfirm: true,
                        },
                        methods: {
                            open: (item) => {
                                this.$_resetDate();
                                this.dialog.site.data.row = item
                                this.dialog.site.visible = true;
                                if (item) {
                                    this.dialog.site.data.site.license_end = this.$_handleTime(item.license_end);
                                    this.dialog.site.data.site.address = item.address;
                                    this.dialog.site.data.site.site_name = item.site_name;
                                    this.dialog.site.data.site.sn = item.sn;
                                    this.dialog.site.data.site.access_key = item.access_key;

                                    this.dialog.site.data.province = item.province;
                                    this.dialog.site.data.province_code = item.province_code;
                                    this.dialog.site.data.city = item.city;
                                    this.dialog.site.data.city_code = item.city_code;
                                    this.dialog.site.data.district = item.district;
                                    this.dialog.site.data.district_code = item.district_code;

                                    this.dialog.site.data.id = item.id;
                                    this.$_getCitysList(this.dialog.site.data.province_code)
                                    this.$_getDistrictsList(this.dialog.site.data.city_code)
                                    this.dialog.site.title = "修改站点信息"
                                } else {
                                    this.dialog.site.data.site.license_end = '';
                                    this.dialog.site.data.site.address = '';
                                    this.dialog.site.data.site.site_name = '';
                                    this.dialog.site.data.province = '';
                                    this.dialog.site.data.province_code = '';
                                    this.dialog.site.data.city = '';
                                    this.dialog.site.data.city_code = '';
                                    this.dialog.site.data.district = '';
                                    this.dialog.site.data.district_code = '';
                                    this.dialog.site.data.id = '';
                                    this.dialog.site.title = "新增站点"
                                }
                            },
                            confirm: () => {
                                if (!this.dialog.site.data.row) {
                                    this.$_newSite();
                                } else {
                                    this.$_editorSite(this.dialog.site.data.row);
                                }
                            }
                        },
                        data: {
                            row: {},
                            site: {
                                license_end: '',
                                address: '',
                                site_name: '',
                                license: '',
                                region: '',
                                sn: '',
                                access_key: '',
                            },
                            id: '',
                            city: '',
                            city_code: '',
                            province: '',
                            province_code: '',
                            district: '',
                            district_code: '',
                            showMore: false,
                            showTip: false,
                        },
                    },
                    reset: {
                        visible: false,
                        title: "密钥",
                        style: {
                            showConfirm: true,
                            width: '400px'
                        },
                        methods: {
                            open: (item) => {
                                this.dialog.reset.data.row = item
                                this.dialog.reset.visible = true;
                            },
                            confirm: () => {
                                this.$_resetKey(this.dialog.reset.data.row.sn)
                            }
                        },
                        data: {
                            row: {},
                        },
                    },
                    delete: {
                        visible: false,
                        title: "删除站点",
                        style: {
                            showConfirm: true,
                            width: '400px'
                        },
                        methods: {
                            open: (item) => {
                                this.dialog.delete.data.row = item
                                this.dialog.delete.visible = true;
                            },
                            confirm: () => {
                                this.$_deleteSite(this.dialog.delete.data.row.sn)
                            }
                        },
                        data: {
                            row: {},
                        },
                    },
                },
            }
        },
        mounted() {
            this.$_getProvinceList();
            this.$_getTableList();
        },
        methods: {
            $_getTableList: async function () {
                this.tableOption.loading = true;
                let params = {
                    site_name: this.searchParmas,
                    page: this.pager.page,
                    per_page: this.pager.per_page
                }
                let data = await this.$api.adminSiteManaging.getList.getPendList.call(this, params);
                if (data !== false) {
                    this.pager.total = data.total;
                    this.tableOption.data = data.items;
                }
                this.tableOption.loading = false;
            },
            $_getProvinceList: async function () {
                let params = {}
                let data = await this.$api.adminSiteManaging.getList.getProvinces.call(this, params);
                if (data !== false) {
                    this.provinceList = data;
                    this.$_handleProvinceList();
                }
            },
            $_getCitysList: async function (item) {
                this.cityList = [];
                this.citySelect = [];
                let params = {
                    province: item
                }
                let data = await this.$api.adminSiteManaging.getList.getCity.call(this, params);
                if (data !== false) {
                    this.cityList = data;
                    this.$_handleCityList();
                }
            },
            $_getDistrictsList: async function (item) {
                this.districtsList = [];
                this.districtsSelect = [];
                let params = {
                    city: item
                }
                let data = await this.$api.adminSiteManaging.getList.getDistricts.call(this, params);
                if (data !== false) {
                    this.districtsList = data;
                    this.$_handleDistrictsListList();
                }
            },
            $_newSite: async function (item) {
                let formData = new FormData();
                formData.append("license_end", this.dialog.site.data.site.license_end + ' 23:59:59');
                formData.append("address", this.dialog.site.data.site.address);
                formData.append("region", this.dialog.site.data.district);
                formData.append("site_name", this.dialog.site.data.site.site_name);
                let data = await this.$api.adminSiteManaging.do.newSite.call(this, formData);
                if (data !== false) {
                    this.$_getTableList();
                    this.$message.success("创建成功.");
                }
                this.dialog.site.visible = false;
            },
            $_editorSite: async function (item) {
                // debugger
                // let params = {
                //     address: this.dialog.site.data.site.address,
                //     license: this.dialog.site.data.site.license,
                //     region: item.district_code,
                //     site_name: this.dialog.site.data.site.site_name,
                //     sn: item.sn
                // }
                let formData = new FormData();
                formData.append("license_end", (this.dialog.site.data.site.license_end.indexOf(':') > 0) ? this.dialog.site.data.site.license_end : (this.dialog.site.data.site.license_end + ' 23:59:59'));
                formData.append("address", this.dialog.site.data.site.address);
                formData.append("region", item.district_code);
                formData.append("site_name", this.dialog.site.data.site.site_name);
                formData.append("sn", this.dialog.site.data.site.sn);
                formData.append("access_key", this.dialog.site.data.site.access_key);
                let params = {
                    form: formData,
                    id: item.id
                }
                let data = await this.$api.adminSiteManaging.do.editorSite.call(this, params);
                if (data !== false) {
                    this.$_getTableList();
                    this.$message.success("修改成功.");
                    this.dialog.site.visible = false;
                }
            },
            $_deleteSite: async function (item) {
                let params = {
                    sn: item,
                }
                let data = await this.$api.adminSiteManaging.do.deleteSite.call(this, params);
                if (data !== false) {
                    this.$_getTableList();
                    this.$message.success("删除成功.");
                }
                this.dialog.delete.visible = false;
            },
            $_resetKey: async function (item) {
                let params = {
                    sn: item,
                }
                let data = await this.$api.adminSiteManaging.getList.resetKey.call(this, params);
                if (data !== false) {
                    this.$_getTableList();
                    this.$message.success("重置成功.");
                }
                this.dialog.reset.visible = false;
            },
            $_selectRegion(item) {
                this.dialog.site.data.site.region = item
            },
            $_handleProvinceList() {
                for (let i = 0; i < this.provinceList.length; i++) {
                    let obj = {
                        value: this.provinceList[i].province_code,
                        label: this.provinceList[i].province
                    };
                    this.provinceSelect.push(obj)
                }
            },
            $_handleCityList() {
                for (let i = 0; i < this.cityList.length; i++) {
                    let obj = {
                        value: this.cityList[i].city_code,
                        label: this.cityList[i].city
                    };
                    this.citySelect.push(obj)
                }
            },
            $_handleDistrictsListList() {
                for (let i = 0; i < this.districtsList.length; i++) {
                    let obj = {
                        value: this.districtsList[i].district_code,
                        label: this.districtsList[i].district
                    };
                    this.districtsSelect.push(obj)
                }
            },
            $_handlerDialogData(data1, data2) {
                for (let i in data1) {
                    if (data2[i] !== undefined) {
                        data1[i] = data2[i];
                    } else {
                        data1[i] = null;
                    }
                }
                return data1;
            },
            $_resetDate() {
                this.dialog.site.data.site.address = '';
                this.dialog.site.data.site.site_name = '';
                this.dialog.site.data.site.region = '';
                this.dialog.site.data.site.license = '';
                this.dialog.site.data.site.license_end = '';
                this.dialog.site.data.site.sn = '';
                this.dialog.site.data.site.access_key = '';
                this.dialog.site.data.city = '';
                this.dialog.site.data.id = '';
                this.dialog.site.data.province = '';
                this.dialog.site.data.district = '';
                this.dialog.site.data.city_code = '';
                this.dialog.site.data.province_code = '';
                this.dialog.site.data.district_code = '';
                this.dialog.site.data.showMore = false;
                this.dialog.site.data.showTip = false;
                this.cityList = [];
                this.citySelect = [];
                this.districtsList = [];
                this.districtsSelect = [];
            },
            $_handleTime(time) {
                let origindate = Date.parse(time);
                let date = new Date(origindate + 8 * 60 * 60 * 1000)
                let Y = date.getFullYear() + '-';
                let M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
                let D = date.getDate() + ' ';
                let h = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':';
                let m = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) + ':';
                let s = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds();
                return Y + M + D + h + m + s
                // return date;
            },
          showMore() {
            this.dialog.site.data.showMore = !this.dialog.site.data.showMore;
          },
          showTip() {
            this.dialog.site.data.showTip = !this.dialog.site.data.showTip;
          },
        },
        watch: {
            pager: {
                deep: true,
                handler: function () {
                    this.$_getTableList();
                },
            },
        }
    }
</script>

<style lang="less" scoped>
    .site-managing {
        width: 100%;

        .deal-item {
            cursor: pointer;
            color: #1890FF;
        }

        .key {
            min-width: 200px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
        }

        .el-dialog {
            .require {
                color: red
            }

            .site-item {
                display: inline-flex;
                align-items: center;
                width: 100%;
                margin-bottom: 20px;

                label {
                    width: 100px;
                    text-align: right;
                }

                .site-input {
                    flex: 1;
                    padding-left: 10px;
                }
            }
        }

        .editor-tip {
          margin-top: 10px;
          i {
            cursor: pointer;
            display: inline-block;
            margin: 0 3px;
          }
        }
    }
</style>
<style lang="less">
        .dialog-tip {
          .el-dialog__body {
            padding-top: 0;
            p {
              font-size: 16px;
            }
          }
        }
</style>
